import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  Grid,
  useTheme,
  View,
  CheckboxField,
  TextAreaField,
  Fieldset,
  SelectField,
  ScrollView,
  Alert,
  Autocomplete,
  Rating,
  Icon,
} from "@aws-amplify/ui-react";
import "./Badanti.css";
import { formConfig } from "./config";
import { MdStar } from "react-icons/md";
import { getBadantiValues } from "../../data/api";

const BadanteFilters = (props) => {

  // download all possible values for form
  const [optionsList, setOptionsList] = useState(() => {
    const storage = localStorage.getItem('badantiValues');
    return storage ? JSON.parse(storage) : {};
  });
  const getOptions = async () => {
    try{
      const responseValues = await getBadantiValues();
      setOptionsList(responseValues);
      localStorage.setItem('badantiValues', JSON.stringify(responseValues))
    } catch (e) {
      console.log("Error retrieving options list " + e)
    }
  }
  useEffect(() => {
    getOptions()
  }, [])
  
  const [hover, setHover] = useState(null);
  const renderField = (field, nestedField, index?, outerField?, innerField?) => {
    const propsValue = nestedField == true ? (props.value[outerField]?.[index]) : props.value;
    const value = nestedField == true ? (props.value[outerField]?.[index]?.[innerField]) : props.value[field.name];
    const savedValue = nestedField == true ? (props.savedValue[outerField]?.[index]?.[innerField]) : props.savedValue[field.name];
    if(field.hidden) return <></>;
    switch (field.type) {
      case "TextField":
        switch(field.dataType){
          case 'number':
            return <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            <Grid 
                templateColumns={{ base: '1fr', large: '1fr 1fr' }}
                gap='5px'
                >    
            <TextField
              value={value?.min}
              onChange={(e) => props.onChange({ target: { name: field.name, value: {...value, min: e.target.value} }})}
              onBlur={props.onBlur}
              name={field.name}
              label={"minimo"}
              type="number"
              isRequired={field.isRequired}
            />
            <TextField
              value={value?.max}
              onChange={(e) => props.onChange({ target: { name: field.name, value: {...value, max: e.target.value} }})}
              onBlur={props.onBlur}
              name={field.name}
              label={"massimo"}
              type="number"
              isRequired={field.isRequired}
            /></Grid>
          </View>
          case 'date':
            return (
              <View columnSpan={field.columnSpan} key={field.name}>
                <Text><b>{field.label}</b></Text>
                
            <Grid 
                templateColumns={{ base: '1fr', large: '1fr 1fr' }}
                gap='5px'
                >    <TextField
                  value={value?.from}
                  onChange={(e) => props.onChange({ target: { name: field.name, value: {...value, from: e.target.value} }})}
                  onBlur={props.onBlur}
                  name={field.name}
                  label={"dal"}
                  type="date"
                  isRequired={field.isRequired}
                />
                <TextField
                  value={value?.to}
                  onChange={(e) => props.onChange({ target: { name: field.name, value: {...value, to: e.target.value} }})}
                  onBlur={props.onBlur}
                  name={field.name}
                  label={"al"}
                  type="date"
                  isRequired={field.isRequired}
                /></Grid>
              </View>
            );
          default:
            return (
              <View columnSpan={field.columnSpan} key={field.name}>
                <TextField
                  value={value}
                  onChange={props.onChange}
                  onBlur={props.onBlur}
                  name={field.name}
                  label={<Text><b>{field.label}</b></Text>}
                  type={field.dataType}
                  isRequired={field.isRequired}
                />
              </View>
            );
        }
      case "RatingField":
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <View marginBottom="10px"><b>{field.label}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
            <Flex>
              {[...Array(5)].map((_, index) => {
                const ratingValue = index + 1;
                return (
                  <label key={index}>
                    <input
                      type="radio"
                      name="rating"
                      value={ratingValue}
                      onClick={() => props.onChange({ target: { name: field.name, value: ratingValue} })}
                      style={{ display: 'none' }}
                    />
                    <Icon
                      as={MdStar}
                      color={ratingValue <= (hover || value) ? '#ffc107' : '#e4e5e9'}
                      onMouseEnter={() => setHover(ratingValue)}
                      onMouseLeave={() => setHover(null)}
                      onClick={() => props.onChange({ target: { name: field.name, value: ratingValue}})}
                      cursor="pointer"
                    />
                  </label>
                );
              })}
            </Flex>
          </View>
        );
      case "SelectField":
      case "CheckboxField":
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <View marginBottom="10px"><b>{field.label}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
            <Grid 
                templateColumns={{ base: '1fr', large: '1fr 1fr' }}
                gap='5px'
                >                  {optionsList[innerField ?? field.name]?.map(option => (
                <CheckboxField
                  key={option}
                  value={option}
                  name={option}
                  label={option}
                  checked={value?.find(v => v === option) !== undefined}
                  onBlur={props.onBlur}
                  onChange={(e) => {
                    const valueArray = value || [];
                    if (e.target.checked) {
                      props.onChange({ target: { name: field.name, value: [...valueArray, option] } });
                    } else {
                      props.onChange({ target: { name: field.name, value: valueArray.filter(v => v !== option) } });
                    }
                  }}
                />
              ))}
            </Grid>
          </View>
        );
      case "TextAreaField":
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <TextAreaField
              value={value}
              onChange={props.onChange}
              onBlur={props.onBlur}
              name={field.name}
              label={<Text><b>{field.label}</b>{value !== savedValue && <i> (modificato)</i>}</Text>}
              isRequired={field.isRequired}
            />
          </View>
        );
      case "CheckboxDateField":
          return (
            <View columnSpan={field.columnSpan} key={field.name}>
              <View marginBottom="10px"><b>{field.label}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
              <View style={{'display': 'grid', 'gridTemplateColumns': 'repeat(3, 1fr)', 'gap': '5px'}}>
                {optionsList[innerField ?? field.name]?.map((option, index) => (
                  <View key={option}>
                    <CheckboxField
                      value={option}
                      name={option}
                      label={option}
                      checked={value?.find(v => v.id === option) !== undefined}
                      onBlur={props.onBlur}
                      onChange={(e) => {
                        const valueArray = value || [];
                        if (e.target.checked) {
                          props.onChange({ target: { name: field.name, value: [...valueArray, {id: option, ora_inizio: '', ora_fine: ''}] } });
                        } else {
                          props.onChange({ target: { name: field.name, value: valueArray.filter(v => v.id !== option) } });
                        }
                      }}
                    />
                      <Flex marginBottom="10px">
                      <TextField
                        disabled={value?.find(v => v.id === option) === undefined}
                        size="small"
                        key={option+"ora_inizio"}
                        value={value?.find(v => v.id === option)?.ora_inizio}
                        onBlur={props.onBlur}
                        onChange={(e) => {
                          const valueArray = value || [];
                          props.onChange({ 
                            target: { name: field.name, value: valueArray.map(v => {
                              return v.id === option ? {...v, ora_inizio: e.target.value} : v
                            })}
                          })
                        }}
                        name={"ora_inizio"}
                        type="time"
                        label={"dalle"}
                      />
                      <TextField
                        disabled={value?.find(v => v.id === option) === undefined}
                        size="small"
                        key={option+"ora_fine"}
                        value={value?.find(v => v.id === option)?.ora_fine}
                        onBlur={props.onBlur}
                        onChange={(e) => {
                          const valueArray = value || [];
                          props.onChange({ 
                            target: { name: field.name, value: valueArray.map(v => {
                              return v.id === option ? {...v, ora_fine: e.target.value} : v
                            })}
                          })
                        }}
                        name={"ora_fine"}
                        type="time"
                        label={"alle"}
                      />
                      </Flex> 
                  </View>
                ))}
              </View>
            </View>
          );
      default:
        return null;
    }
  };

  return (
    <Grid 
      templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
      gap="20px">
      {formConfig.sections.filter(s => !s.hideFilter).map((section) => (
          <React.Fragment key={section.title}>
            <View columnSpan={[1, 1, 1, 4]}><h4>{section.title}</h4></View>
            {section.fields
              .filter(f => ((props.filterType ?? '') === 'bozza' ? !f.hideBozza : true))
              .map(o => renderField(o, false))
            }
            <View columnSpan={[1, 1, 1, 4]}></View>
          </React.Fragment>
      ))}
    </Grid>
  );
};

export default BadanteFilters;
